import script from "./supplier-order.vue?vue&type=script&lang=tsx&setup=true"
export * from "./supplier-order.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__